import AddressList from "./components/List"
import AddressForm from "./components/Form"
import AddressView from "./components/View"

let module = "addresses"

export default [
  { path: "addresses", component: AddressList, meta: { module: module, permissions: ["address-access"] } },
  {
    path: "addresses/create",
    component: AddressForm,
    props: true,
    meta: { module: module, permissions: ["address-create"] }
  },
  {
    path: "addresses/edit/:id",
    component: AddressForm,
    props: true,
    meta: { module: module, permissions: ["address-edit"] }
  },
  {
    path: "addresses/view/:id",
    component: AddressView,
    props: true,
    meta: { module: module, permissions: ["address-access"] }
  }
]
